import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';
import { Dropdown } from '@els/els-react--dropdown';
import UserDatabases from '@Services/UserDatabases';
import SelectedItemsCount from '@Containers/ResultsFilters/ResultsFiltersComponents/SelectedItemsCount/SelectedItemsCount';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { TextInput } from '@els/els-react--text-input';

import './SuggestModalHeader.custom.scss';
import './SuggestModalHeader.theme.scss';

function SuggestModalHeader({ noData, opModel, database, suggestConfig, searchByKeyword, expandedValue, clearSelected }) {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (expandedValue === searchValue) {
      return;
    }
    if (!expandedValue && expandedValue !== '') {
      return;
    }

    setSearchValue(expandedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedValue]);

  const handleSearchChange = (value) => {
    const trimmedValue = value.trim();
    if (trimmedValue === searchValue) {
      return;
    }

    setSearchValue(trimmedValue);
    searchByKeyword(trimmedValue);
  };

  const databaseDropdownOptions =
    suggestConfig.databases &&
    suggestConfig.databases.map((databaseId) => ({
      label: UserDatabases.getDbName(databaseId),
      value: databaseId,
    }));
  const formattedDropdownOptions =
    databaseDropdownOptions &&
    databaseDropdownOptions.map((item) => ({
      label: item.label,
      id: item.value,
    }));
  const selectedDatabaseOption = databaseDropdownOptions.find((db) => db.value === database);
  return (
    <div className="suggestModal__header">
      <h2>{opModel.title}</h2>
      <hr className="u-els-margin-top-1o2 suggest-modal-header-devider" />
      <div className="suggest-modal-dialog-header-controls-wrapper u-els-margin-top u-els-margin-bottom-1o2">
        <section className="section-left">
          {!noData && (
            <section className="section-left-top">
              <TextInput
                id="suggestModal__header_input"
                value={searchValue}
                label="Search"
                shouldHideLabel
                iconRight={{
                  sprite: 'Search',
                  a11y: {
                    name: 'Search',
                  },
                }}
                onChange={(e) => handleSearchChange(e.target.value)}
              />
            </section>
          )}
          <section className="section-left-bottom u-els-margin-top">
            <section>
              <SelectedItemsCount count={opModel.selection && opModel.selection.length} showZero />
              <span className={classnames('selected-items-count-label', 'u-els-margin-left-1o4')}>selected</span>
            </section>
            <section>
              <ButtonWithIcon
                disabled={isEmpty(opModel.selection)}
                type="link"
                sprite="Trash"
                iconRight
                className="suggest-modal-header-controls-clear-selected u-els-margin-left"
                data-automationId="suggest-modal-header-clear-selected"
                id="suggest-modal-header-sorting-clear-selected"
                onClick={clearSelected}>
                Clear selected
              </ButtonWithIcon>
            </section>
          </section>
        </section>
        <section className="section-right">
          <Dropdown
            label={`Database: ${get(selectedDatabaseOption, 'label', '')}`}
            options={formattedDropdownOptions}
            showSelectedAsLabel={false}
            selected={selectedDatabaseOption}
            id="suggest-modal-dialog-sorting-dropdown"
            className="suggest-modal-dialog__sorting-dropdown"
            flyoutProps={{
              placement: 'bottom-end',
              pointer: true,
              pointerType: 'primary',
              width: '200px',
            }}
          />
        </section>
      </div>
    </div>
  );
}

SuggestModalHeader.propTypes = {
  noData: PropTypes.bool,
  opModel: PropTypes.object,
  suggestConfig: PropTypes.object,
  database: PropTypes.string,
  searchByKeyword: PropTypes.func.isRequired,
  expandedValue: PropTypes.string,
  clearSelected: PropTypes.func,
};

export default SuggestModalHeader;
